module.exports = __webpack_public_path__ + "static/img/weixin-service.a0c61dc2.png";